import React, { useState, useEffect } from 'react'
import { Th, TableContext, Td } from './AdminTemplate/Table'
import { Table as StrapTable } from 'reactstrap'
import FlexLayout from './FlexLayout'
import Text from './Text'

function Table({
  name = '',
  headers = [],
  initData,
  style,
  styleRow = {},
  clickRow = () => {},
  doubleClickRow = () => {},
  hover = () => {},
  styleTd = ''
}) {
  const ordering = headers.reduce(
    (acc, head) => ({ ...acc, [head.name]: null }),
    {}
  )
  const [data, setData] = useState(initData)

  const updateOrdering = (orderName, direction) => {
    const order = headers.reduce(
      (acc, head) => ({ ...acc, [head.name]: null }),
      {}
    )
    const newOrdering = { ...order, [orderName]: direction }

    if (
      headers.reduce(
        (acc, head) => (acc === newOrdering[head.name] ? null : undefined),
        null
      ) === null
    ) {
      setData(initData)
      return
    }

    function compareAsc(a, b) {
      if (a[orderName] < b[orderName]) {
        return -1
      }
      if (a[orderName] > b[orderName]) {
        return 1
      }
      return 0
    }
    function compareDesc(a, b) {
      if (a[orderName] > b[orderName]) {
        return -1
      }
      if (a[orderName] < b[orderName]) {
        return 1
      }
      return 0
    }

    setData((prev) => {
      prev.sort(direction === 'asc' ? compareAsc : compareDesc)
      return [...prev]
    })
  }

  useEffect(() => {
    setData(initData)
  }, [initData])

  return (
    <FlexLayout direction="column" style={style}>
      {name && <Text textType="header2" text={name} />}
      <TableContext updateOrdering={updateOrdering} initialOrdering={ordering}>
        <StrapTable
          bordered
          hover={hover != undefined && hover == true ? true : false}
        >
          <thead>
            <tr>
              {headers.map((header) => (
                <Th key={header.label} orderable orderName={header.name}>
                  <Text style={{ display: 'inherit' }}>{header.label}</Text>
                </Th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={i}
                style={{ ...styleRow }}
                onDoubleClick={() =>
                  typeof doubleClickRow == 'function'
                    ? doubleClickRow(item)
                    : null
                }
                onClick={() =>
                  typeof clickRow == 'function' ? clickRow(item) : null
                }
              >
                {headers.map((v) => (
                  <Td
                    key={v.name}
                    style={{
                      maxWidth: '250px',
                      wordBreak: 'break-word',
                      textAlign: v.align == undefined ? '' : v.align,
                      ...item.styleCell
                    }}
                  >
                    {item[v.name]}
                  </Td>
                ))}
                {item.extra && <Td>{item.extra}</Td>}
              </tr>
            ))}
          </tbody>
        </StrapTable>
      </TableContext>
    </FlexLayout>
  )
}

export default Table
